import type { ReactNode } from 'react';
import { AlertCircle, CheckCircle2 } from 'lucide-react';

interface FieldProps {
  label: string;
  htmlFor: string;
  required?: boolean;
  error?: string | null;
  hint?: string | null;
  help?: string;
  children: ReactNode;
}

export default function Field({
  label,
  htmlFor,
  required,
  error,
  hint,
  help,
  children,
}: FieldProps) {
  return (
    <div className="space-y-1">
      <label htmlFor={htmlFor} className="text-xs font-medium block">
        {label}
        {required && <span className="text-destructive ml-0.5">*</span>}
      </label>
      {children}
      {error ? (
        <div className="text-[11px] text-destructive flex items-center gap-1">
          <AlertCircle className="h-3 w-3 shrink-0" aria-hidden />
          {error}
        </div>
      ) : hint ? (
        <div className="text-[11px] text-muted-foreground flex items-center gap-1">
          <CheckCircle2 className="h-3 w-3 shrink-0 text-primary/70" aria-hidden />
          {hint}
        </div>
      ) : help ? (
        <div className="text-[11px] text-muted-foreground">{help}</div>
      ) : null}
    </div>
  );
}
